import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import { ajustarTamanhoFonte } from "../../../estilos/global";
import { cores, estiloCampo, estiloRotulo } from "./estilosCatalogoEnsino";

export function CampoCatalogo({ id, rotulo, obrigatorio = false, numero, opcoes, ...props }) {
  return (
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography
        component="label"
        id={`${id}-rotulo`}
        htmlFor={id}
        sx={estiloRotulo}
      >
        {numero && (
          <Box
            component="span"
            aria-hidden="true"
            sx={{ display: "inline-grid", placeItems: "center", width: 22, height: 22, mr: 0.5, borderRadius: "50%", bgcolor: "var(--sear-acao-azul, #087cf0)", color: "#fff", fontSize: ajustarTamanhoFonte("12px"), flexShrink: 0 }}
          >
            {numero}
          </Box>
        )}
        {rotulo}
        {obrigatorio && <Box
          component="span"
          aria-hidden="true"
          sx={{ color: "var(--sear-erro-texto, #e43c4e)" }}
        >*</Box>}
      </Typography>
      <TextField
        {...props}
        id={id}
        fullWidth
        size="small"
        select={Boolean(opcoes)}
        SelectProps={opcoes ? { native: true } : undefined}
        inputProps={{ "aria-labelledby": `${id}-rotulo`, "aria-required": obrigatorio, maxLength: 150 }}
        sx={[estiloCampo, opcoes && { "& .MuiNativeSelect-select": { color: props.value ? cores.texto : cores.secundario } }]}
      >
        {opcoes?.map(({ valor, texto }) => <option
          key={valor}
          value={valor}
        >{texto}</option>)}
      </TextField>
    </Box>
  );
}

export function CampoLinha({ rotulo, opcoes, ...props }) {
  return (
    <TextField
      {...props}
      fullWidth
      size="small"
      select={Boolean(opcoes)}
      SelectProps={opcoes ? { native: true } : undefined}
      inputProps={{ "aria-label": rotulo, maxLength: 150 }}
      sx={[estiloCampo, { minWidth: 0 }, opcoes && { "& .MuiNativeSelect-select": { color: props.value ? cores.texto : cores.secundario } }]}
    >
      {opcoes?.map(({ valor, texto }) => <option
        key={valor}
        value={valor}
      >{texto}</option>)}
    </TextField>
  );
}
